// ArChat — Runtime logger (sin consola como canal principal): buffer + localStorage + export JSON

const STORAGE_KEY = 'archat_runtime_log_v1';
const MAX_BUFFER = 8000;
const PERSIST_SLICE = 500;

/** @type {Array<{ timestamp: string, type: string, context: string, data: * }>} */
const buffer = [];

function safeStringify(data) {
  try {
    if (data === undefined) return null;
    return JSON.parse(JSON.stringify(data, (_k, v) => (typeof v === 'bigint' ? String(v) : v)));
  } catch {
    return { _nonSerializable: String(data) };
  }
}

function loadFromStorage() {
  if (typeof localStorage === 'undefined') return;
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return;
    const parsed = JSON.parse(raw);
    if (Array.isArray(parsed) && parsed.length > 0) {
      buffer.length = 0;
      buffer.push(...parsed.slice(-MAX_BUFFER));
    }
  } catch {
    // noop
  }
}

function persistIncremental() {
  if (typeof localStorage === 'undefined') return;
  try {
    const toSave = buffer.slice(-Math.max(PERSIST_SLICE, buffer.length));
    localStorage.setItem(STORAGE_KEY, JSON.stringify(toSave));
  } catch {
    try {
      const trimmed = buffer.slice(-200);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(trimmed));
    } catch {
      try {
        localStorage.removeItem(STORAGE_KEY);
      } catch {
        // noop
      }
    }
  }
}

if (typeof window !== 'undefined') {
  loadFromStorage();
  window.__ARCHAT_RUNTIME_LOG__ = buffer;
  window.__ARCHAT_EXPORT_LOGS__ = exportLogsToFile;
}

/**
 * Registra un evento de trazabilidad (canal principal: buffer + persistencia).
 * @param {string} type
 * @param {string} [context]
 * @param {*} [data]
 */
export function logEvent(type, context = '', data = null) {
  const entry = {
    timestamp: new Date().toISOString(),
    type: String(type ?? ''),
    context: context == null ? '' : String(context),
    data: data == null ? null : safeStringify(data),
  };
  buffer.push(entry);
  if (buffer.length > MAX_BUFFER) {
    buffer.splice(0, buffer.length - MAX_BUFFER);
  }
  persistIncremental();
}

/**
 * Descarga un JSON con todo el buffer en memoria (sesión actual + último slice persistido).
 */
export function exportLogsToFile() {
  if (typeof document === 'undefined' || typeof Blob === 'undefined') return;
  logEvent('LOGGER_EXPORT', 'exportLogsToFile', { count: buffer.length });
  const payload = {
    exportedAt: new Date().toISOString(),
    count: buffer.length,
    events: [...buffer],
  };
  const blob = new Blob([JSON.stringify(payload, null, 2)], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `archat-runtime-log-${Date.now()}.json`;
  a.rel = 'noopener';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

export function getRuntimeLogSnapshot() {
  return [...buffer];
}
